// Find DBK API script path from the host page scripts (cached)
let dbkAPIScriptPath = '';
export function getAPIScriptPath() {
    if (!dbkAPIScriptPath) {
        const { scripts } = document;

        const dbkScript = Array.from(scripts).find(
            (script) => script.src && script.src.includes('DBKAPI.js'),
        );

        if (dbkScript) {
            dbkAPIScriptPath = dbkScript.src;
        }
    }

    return dbkAPIScriptPath;
}

// Inject DBK script into the iframe and evaluate aspect snippets.
export function injectIframeAspects(dbkSession, query, iframeAspects) {
    if (!iframeAspects || !iframeAspects.length) return;

    try {
        const divFrame = document.querySelector(query);
        const iframeEl = divFrame?.children?.[0] || null;

        if (!iframeEl) {
            console.log('Iframe not found with selector:', query);

            return;
        }

        const iframeWindow = iframeEl.contentWindow;

        if (!iframeWindow || !iframeWindow.document) {
            console.log('Iframe window/document not available yet');

            return;
        }

        const { document: iframeDocument } = iframeWindow;

        const dbkScript = iframeDocument.createElement('script');
        dbkScript.src = getAPIScriptPath();

        dbkScript.onload = () => {
            // initialize DBK inside the iframe
            try {
                iframeWindow.dbk.init(dbkSession ?? {});
            } catch (initErr) {
                console.log('Error initializing dbk in iframe', initErr);
            }

            // execute each aspect's snippet inside iframe context
            iframeAspects.forEach((aspect) => {
                const { sourceSnippet } = aspect || {};

                if (!sourceSnippet) return;

                try {
                    iframeWindow.eval(sourceSnippet);
                } catch (e) {
                    console.log('Error loading aspect in frame', e);
                }
            });
        };

        iframeDocument.body.appendChild(dbkScript);
    } catch (e) {
        console.log('Error trying to load aspect in child frame', e);
    }
}
